import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, Router } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { InfozoneDirective } from './directives/infozone.directive';
import { VideoDirective } from './directives/video.directive';
// import { VideobuttonComponent } from './components/videobutton/videobutton.component';
// import { InfozonebuttonComponent } from './components/infozonebutton/infozonebutton.component';
import { ComponentsModule } from './components/components.module';
import { GlobalErrorHandler, HttpConfigInterceptor } from './interceptors/auth.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimations } from '@angular/platform-browser/animations';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppBootstrapService } from './services/app-bootstrap.service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { CapacitorFileTranslateLoader } from './services/capacitor-file.loader';
import { HttpClient } from '@angular/common/http';
// Factory function for AoT compatibility
export function httpLoaderFactory(http: HttpClient) {
  return new CapacitorFileTranslateLoader(http);
}

export function bootstrapAppFactory(appBootstrapService: AppBootstrapService): () => Promise<void> {
  return () => appBootstrapService.initialize();
}

@NgModule({                     
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AppComponent,
    InfozoneDirective,
    VideoDirective,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      mode: 'ios',
      innerHTMLTemplatesEnabled: true,
      focusManagerPriority: ['heading', 'content', 'banner']
    }),
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    BrowserAnimationsModule,
    CommonModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: bootstrapAppFactory,
      deps: [AppBootstrapService],
      multi: true
    },
    provideAnimations(),
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
  ],
  bootstrap: [AppComponent],
  exports: []
})
export class AppModule { }
